/* eslint-disable react/display-name */
import { lazy } from "react";
const ConfigCamera = lazy(() => import("./components/camera-location"));
const ConfigUser = lazy(() => import("./components/camera-user"));
const RequestAuthorization = lazy(() => import("./components/request-authorization"));
const PermissionCameraManagement = lazy(() => import("./components/permission-camera-management"));

const CameraConfigRoutes = [
  { path: "location", element: <ConfigCamera /> },
  { path: "users", element: <ConfigUser /> },
  { path: "requests", element: <RequestAuthorization /> },
  { path: "permission-camera-management", element: <PermissionCameraManagement /> },
];

export default CameraConfigRoutes;
